export default function ownerDocument(element) {
    return element.ownerDocument || element.document || element;
}



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-popup-common/dist/es/owner-document.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/owner-document.js
// module chunks = vendor